'use client'

import { RecaptchaProvider } from '@/components/v2/molecules/providers/recaptchaProvider'

export default function WeddingVenuesLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return <RecaptchaProvider>{children}</RecaptchaProvider>
}
